import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  async function handleDelete() {
    try {
      return resource.delete();
    } catch (e) {
      displayErrorMessage(e, e.errors || 'Error: Failed to delete');
      return undefined;
    }
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  return (
    <PXFormModalWrapper>
      <MetaLayoutRemainingFields expanded fullWidth />
      {resource.meta().canDelete() ? (
        <WizardStepDeleteButton
          onDelete={handleDelete}
          onDeleteSuccess={onDeleteSuccess}
          dialogProps={{
            title: 'Are you sure?',
            message: 'Removing this item will delete all of its information. This cannot be undone.',
            confirmLabel: 'Remove',
          }}
        />
      ) : null}
    </PXFormModalWrapper>
  );
};

export default Layout;
